import vehicleMotoIcon from '../../../assets/icons/icon_vehicle_moto.png'
import vehicleCarIcon from '../../../assets/icons/icon_vehicle_car.png'
import vehicleElectricIcon from '../../../assets/icons/icon_vehicle_electric.png'

export const TRAFFIC_URLS = {
  trafficFineWeb: process.env.REACT_APP_URL_WEB_THONGBAOPHATNGUOI
}

export const TRAFFIC_THEME = {
  cardBorder: 'var(--v1-border-default)',
  warningBackground: 'var(--v1-action-danger-bg)',
  successBackground: 'var(--v1-action-success-bg)',
  disableBackground: 'var(--v1-action-disabled-bg)'
}

export const TRAFFIC_SEARCH_TYPE = {
  csgt: {
    value: 'cuc_csgt',
    label: 'Tra cứu phạt nguội từ CSGT',
    link: 'https://csgt.vn'
  }
}

export const TRAFFIC_VEHICLE_TYPES = {
  oto: { value: 1, label: 'Ô tô', icon: vehicleCarIcon },
  xemay: { value: 30, label: 'Xe máy', icon: vehicleMotoIcon },
  maydien: { value: 40, label: 'Xe máy điện', icon: vehicleElectricIcon }
}

export const TRAFFIC_ERROR_MESSAGES = {
  INVALID_PLATE_NUMBER: {
    value: 'INVALID_PLATE_NUMBER',
    message: 'Biển số không hợp lệ'
  },
  INVALID_VEHICLE_CERTIFICATE: {
    value: 'INVALID_VEHICLE_CERTIFICATE',
    message: 'Số seri không hợp lệ'
  },
  VEHICLE_NOT_FOUND: {
    value: 'VEHICLE_NOT_FOUND',
    message: 'Không tìm thấy thông tin phương tiện'
  },
  QUOTA_EXCEEDED: {
    value: 'QUOTA_EXCEEDED',
    message: 'Đã đạt giới hạn tra cứu, vui lòng thử lại sau.'
  },
  DEFAULT: {
    value: 'DEFAULT',
    message: 'Mạng đang bận, vui lòng thử lại sau.'
  }
}
